
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinhinnashik() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Nashik',
        heading: 'etravo :  Corporate Cab and Bus Services in Nashik',
        headingDescription: 'eTravo provides dependable Corporate Cab and Bus Services in Nashik, tailored to meet the mobility needs of businesses, manufacturing units, and corporate offices. From executive cab services for client meetings and airport transfers to well-equipped buses for employee commutes and team outings, we ensure timely, safe, and professional transportation. With a focus on reliability, comfort, and operational efficiency, eTravo supports seamless corporate travel across Nashik with GPS-enabled vehicles, trained drivers, and a commitment to service excellence.',

        top: 'Top Places to Visit in Nashik with etravo',
 "topPlaces": [
    {
      "title": "Trimbakeshwar Shiva Temple",
      "description": "Located about 28 km from Nashik, this ancient temple is one of the twelve Jyotirlingas dedicated to Lord Shiva. It's renowned for its unique architecture and the origin point of the sacred Godavari River nearby."
    },
    {
      "title": "Sula Vineyards",
      "description": "India's premier wine destination, Sula Vineyards offers guided tours, wine tastings, and a serene ambiance amidst sprawling vineyards. It's a must-visit for wine enthusiasts and those seeking a relaxed outing."
    },
    {
      "title": "Pandav Leni Caves",
      "description": "Also known as the Nashik Caves, this group of 24 rock-cut caves dates back to between the 1st century BCE and the 3rd century CE. They showcase intricate carvings and are significant for their Buddhist heritage."
    },
    {
      "title": "Kalaram Temple",
      "description": "Situated in the Panchavati area, this historic temple is dedicated to Lord Rama. Built with black stone, it holds immense religious significance and is a prominent pilgrimage site in Nashik."
    },
    {
      "title": "Saptashrungi Devi Temple",
      "description": "Located approximately 60 km from Nashik in Vani, this temple is one of the 51 Shakti Peethas in India. Perched atop a hill, it offers panoramic views and is accessible via a series of steps or a ropeway."
    },
    {
      "title": "Muktidham Temple",
      "description": "A marble temple complex situated in the Nashik Road area, Muktidham houses replicas of 12 Jyotirlingas and other Hindu deities. The intricate architecture and serene environment make it a popular tourist spot."
    },
    {
      "title": "Anjaneri Hills",
      "description": "Believed to be the birthplace of Lord Hanuman, Anjaneri Hills offer trekking opportunities amidst lush greenery. The summit provides breathtaking views of the surrounding landscapes."
    },
    {
      "title": "Harihar Fort",
      "description": "Approximately 40 km from Nashik, Harihar Fort is renowned for its steep, rock-cut steps and offers a challenging trek. The fort's unique architecture and historical significance attract adventure enthusiasts."
    },
    {
      "title": "Ramkund",
      "description": "A sacred bathing ghat on the banks of the Godavari River, Ramkund holds religious importance as it's believed that Lord Rama bathed here. Pilgrims visit to perform rituals and take holy dips."
    },
    {
      "title": "Coin Museum",
      "description": "Located in the scenic surroundings of Anjneri, this museum showcases a vast collection of coins, artifacts, and detailed information about India's numismatic history."
    }
  ],
 "services": [
    {
      "name": "Corporate Transportation Solutions in Nashik",
      "description": "eTravo offers comprehensive corporate transportation solutions in Nashik, designed to meet the daily and occasional travel needs of modern businesses. Whether it's regular staff transport, inter-office transfers, or special event mobility, we provide reliable, tech-enabled services that improve punctuality and employee satisfaction. With safety-first operations, trained chauffeurs, and a responsive support team, eTravo ensures smooth transportation for your entire organization."
    },
    {
      "name": "Bus & Cab Rentals for Businesses in Nashik",
      "description": "Get access to a wide range of bus and cab rental options in Nashik with eTravo's corporate-focused services. From AC hatchbacks for executives to large 40+ seater buses for team movement, we offer cost-effective, contract-based or on-demand rentals. Ideal for companies looking to streamline employee transport, client pickups, or intra-city transfers with consistent service quality."
    },
    {
      "name": "Employee Commute Services Nashik",
      "description": "eTravo’s employee commute services in Nashik are structured around company schedules and employee locations. We help businesses increase staff attendance and reduce travel stress by offering timely pickups, optimized routes, and well-maintained vehicles. Available for multiple shifts and customized according to workforce size, our commute solutions are reliable, scalable, and affordable."
    },
    {
      "name": "Corporate Event Transport Nashik",
      "description": "Planning a corporate event or offsite in Nashik? eTravo provides complete transport logistics for conferences, seminars, workshops, and team outings. We offer end-to-end coordination, from pickup points to venue arrival, with options like AC coaches, tempo travellers, and executive cars. Our experienced logistics team ensures all guests and employees arrive on time and in comfort."
    },
    {
      "name": "Cab Services for Office Staff in Nashik",
      "description": "eTravo delivers safe and professional cab services for office staff in Nashik, whether for daily commutes or occasional use. We offer dedicated cab plans tailored to your organization’s needs. All cabs are GPS-enabled, regularly sanitized, and driven by verified professionals to ensure a secure and efficient experience every day."
    },
    {
      "name": "Air-Conditioned Bus Rentals for Corporates Nashik",
      "description": "Our AC bus rental services in Nashik are perfect for corporates requiring reliable and comfortable staff transport. Whether for daily commute or special requirements like training programs or factory visits, we offer flexible bus sizes with modern amenities and professional drivers. eTravo ensures timely dispatches, regular maintenance, and affordable plans tailored to your team size."
    },
    {
      "name": "Staff Pickup and Drop Services in Nashik",
      "description": "Simplify your company’s transportation with eTravo’s staff pickup and drop services in Nashik. We offer punctual and cost-effective solutions using cabs, vans, and buses. Our services are ideal for factories, call centers, IT companies, and educational institutions looking for organized transport support with round-the-clock operations and excellent service management."
    }
  ],
  "tableData": [
    ["Corporate Transportation Solutions in Nashik", "Bus & Cab Rentals for Businesses in Nashik"],
    ["Employee Commute Services Nashik", "Corporate Event Transport Nashik"],
    ["Cab Services for Office Staff in Nashik", "Air-Conditioned Bus Rentals for Corporates Nashik"],
    ["Staff Pickup and Drop Services in Nashik", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Corporate Transportation in Nashik",
        "WhyChoosedescription": "At eTravo, we understand the importance of punctuality in corporate operations. Our cab and bus services in Nashik are built to support business mobility with reliable scheduling, efficient routing, and on-time pickups and drop-offs—ideal for employee commutes, business meetings, and guest transfers."
    },
    {
        "WhyChooseheading": "Wide Fleet for All Business Needs",
        "WhyChoosedescription": "From premium sedans for executive travel to high-capacity AC buses for large-scale staff transportation, our fleet in Nashik is versatile and modern. Each vehicle is maintained for comfort, hygiene, and performance—ensuring smooth and comfortable travel for professionals and teams alike."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "eTravo’s drivers are professionally trained, background-verified, and courteous. With excellent knowledge of Nashik’s industrial zones, business districts, and traffic patterns, our drivers ensure safe, respectful, and efficient service to meet the high standards expected by corporate travelers."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "We offer upfront pricing tailored to your travel requirements—be it daily shuttles, shift-based staff movement, or executive travel. With eTravo, businesses in Nashik can expect clear, itemized quotes and competitive rates with no hidden fees or unexpected surcharges."
    },
    {
        "WhyChooseheading": "Safety-First Travel Experience",
        "WhyChoosedescription": "All our vehicles are equipped with essential safety features including GPS tracking, seat belts, emergency kits, and fire extinguishers. We also carry out regular sanitization and maintenance, giving businesses peace of mind about their employees’ well-being during transit."
    },
    {
        "WhyChooseheading": "24/7 Support for Flexible Corporate Schedules",
        "WhyChoosedescription": "Business doesn’t stop—and neither do we. eTravo’s transport services in Nashik operate around the clock to meet the demands of companies with night shifts, early meetings, or outstation travel. Our operations team is always available to handle last-minute changes and emergencies."
    },
    {
        "WhyChooseheading": "Easy Booking and Ride Management",
        "WhyChoosedescription": "Managing transportation has never been easier. eTravo provides a centralized booking platform where businesses can schedule rides, manage recurring travel plans, and track vehicles in real-time. Our system simplifies transport logistics so your teams arrive on time, every time."
    },
    {
        "WhyChooseheading": "Customized Corporate Travel Solutions",
        "WhyChoosedescription": "Whether you operate in the manufacturing sector, IT, healthcare, or education, eTravo offers customized transport plans in Nashik that align with your company’s size, industry, and schedule. From fixed-route daily services to flexible, on-demand rides—we tailor every detail to your business needs."
    }
]



























    }

// Corporate Cab and Bus Services in Nashik – eTravo

const faqData = [
    [
        {
            question: 'What corporate transport services does eTravo offer in Nashik?',
            answer: 'eTravo provides reliable corporate cab and bus services in Nashik, including employee commutes, executive transport, business event mobility, and intercity travel for corporate teams.',
        },
        {
            question: 'Can eTravo support shift-based staff transportation for companies in Nashik?',
            answer: 'Yes, we manage daily and shift-based employee transport with optimized routing, scheduled pickups, and well-maintained vehicles suitable for factories, offices, and tech parks in Nashik.',
        },
        {
            question: 'What types of vehicles are available for corporate clients in Nashik?',
            answer: 'Our fleet includes sedans, hatchbacks, SUVs, tempo travellers, and AC buses with 13 to 50 seats — all maintained to high safety and comfort standards for corporate use.',
        },
        {
            question: 'Are tracking and reporting available for all transport services?',
            answer: 'Absolutely. eTravo offers real-time GPS tracking, trip monitoring, driver authentication, and automated reports for transparency and complete control over transport operations.',
        },
        {
            question: 'Can we book eTravo for corporate events or outstation meetings from Nashik?',
            answer: 'Yes, we offer flexible transport for conferences, offsite meetings, industrial visits, and outstation corporate travel with dedicated coordination and support.',
        },
        {
            question: 'Is account management support available for Nashik-based companies?',
            answer: 'Yes, every corporate client receives a dedicated account manager to assist with route planning, bookings, support, invoicing, and service quality tracking.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Nitin Patkar',
        designation: 'Admin Officer, NeoLogix Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s cab and bus service in Nashik is smooth, professional, and always reliable. Our employee transport has become much more organized since we partnered with them.”',
    },
    {
        name: 'Ms. Minal Kale',
        designation: 'HR Executive, Vertex Systems',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo for daily staff travel and occasional corporate trips. Their team is responsive, and the vehicles are always in great condition. Highly recommended in Nashik.”',
    },
];
















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Nashik",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-nashik.jpg",
  "description": "Reliable corporate cab and bus services in Nashik by eTravo. Perfect for employee commute, corporate events, and office staff transport with air-conditioned buses and affordable cab rentals.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2780"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-nashik"
  }
};







    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Nashik | Staff Transport & Corporate Events | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Nashik with eTravo for employee commute, corporate events, and office staff transport. Affordable AC buses and cabs with reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinhinnashik;